import {useMutation, UseMutationResult} from '@tanstack/react-query';
import {useLocale} from 'state/locale';
import Api from 'types/api';
import {request} from 'utils/request';

export type UiLongTask = {
    currentProgress: number;
    errors: string[];
    finished: boolean;
    maxProgress: number;
    mid: string;
    timeDone: string | undefined; // Timestamp or undefined
    url: string;
};

export type LongTask = {
    completion: number;
    finished: string | undefined; // Timestamp or undefined
    mid: string;
    resultUrl: string;
    uilongtask: UiLongTask;
    url: string;
};

export type LongTaskResponseSuccessResponse = Api.Response.Success<LongTask>;

export type LongTaskResponseErrorResponse = Api.Response.Failure<'value'>;

export const useGetLongTaskProgress = (): UseMutationResult<
    LongTaskResponseSuccessResponse,
    LongTaskResponseErrorResponse,
    string
> => {
    const locale = useLocale();

    return useMutation((progressUrl) =>
        request({
            locale,
            method: 'GET',
            uri: progressUrl,
        }),
    );
};

export default useGetLongTaskProgress;
